import { ISnotrRoute } from '..';
import dayjs from '@/utils/dayjs';
import EmptyLayout from '@/layouts/EmptyLayout.vue';

export default [
  {
    path: '/paycheck-reports',
    component: () => import('@/pages/PaycheckReports/paycheck-reports.vue'),
    children: [
      {
        path: '',
        name: 'PaycheckReports',
        meta: {
          title: 'TabTitle.paycheckReports',
          applicationMode: 'PaycheckMode',
        },
        component: () => import('@/pages/PaycheckReports/paycheck-reports-list.vue'),
      },
      {
        path: 'vacation-money-report',
        name: 'PaycheckReportsVacationMoneyReport',
        meta: {
          title: 'TabTitle.vacationMoneyReport',
          applicationMode: 'PaycheckMode',
        },
        props: route => {
          const year = route.query.year ? parseInt(route.query.year as string) : dayjs().year() - 1;
          return { year };
        },
        component: () => import('@/pages/PaycheckReports/VacationMoneyReport/vacation-money-report.vue'),
      },
      {
        path: 'vacation-money-report/pdf',
        name: 'PaycheckReportsVacationMoneyReportPdf',
        meta: {
          layout: EmptyLayout,
          applicationMode: 'PaycheckMode',
        },
        props: route => ({ year: parseInt(route.query.year as string) }),
        component: () => import('@/pages/PaycheckReports/VacationMoneyReport/vacation-money-report-pdf.vue'),
      },
      {
        path: 'amelding-and-bookkeeping-reconciliation',
        name: 'AmeldingAndBookkeepingReconciliation',
        meta: {
          title: 'TabTitle.ameldingAndBookkeepingReconciliation',
          applicationMode: 'PaycheckMode',
        },
        props: route => {
          // we never pass this param as an array, so we can assume it is a string or undefined
          const year = route.query.year ? parseInt(route.query.year as string) : dayjs().year();

          return { year };
        },
        component: () => import('@/pages/PaycheckReports/AmeldingAndBookkeepingReconciliation/amelding-and-bookkeeping-reconciliation.vue'),
      },
      {
        path: 'yearly-report-for-employee',
        name: 'PaycheckReportsYearlyReportForEmployee',
        meta: {
          title: 'TabTitle.yearlyReportForEmployee',
          applicationMode: 'PaycheckMode',
        },
        props: route => {
          const year = route.query.year ? parseInt(route.query.year as string) : dayjs().year() - 1;
          return { year };
        },
        component: () => import('@/pages/PaycheckReports/YearlyReportForEmployee/yearly-report-for-employee.vue'),
      },
      {
        path: 'yearly-report-for-employee/pdf',
        name: 'PaycheckReportsYearlyReportForEmployeePdf',
        meta: {
          layout: EmptyLayout,
          applicationMode: 'PaycheckMode',
        },
        props: route => {
          const year = parseInt(route.query.year as string);
          const workRelationId = route.query.workRelationId;
          return { year, workRelationId };
        },
        component: () => import('@/pages/PaycheckReports/YearlyReportForEmployee/yearly-report-for-employee-pdf.vue'),
      },
      {
        path: 'paychecks-summary-report',
        name: 'PaychecksSummaryReport',
        meta: {
          applicationMode: 'PaycheckMode',
        },
        component: () => import('@/pages/PaycheckReports/PaychecksSummaryReport/paycheck-summary-report.vue'),
      },
      {
        path: 'paychecks-and-bookkeeping-reconciliation',
        name: 'PaychecksAndBookkeepingReconciliationReport',
        meta: {
          title: 'TabTitle.paychecksAndBookkeepingReconciliationReport',
          applicationMode: 'PaycheckMode',
        },
        props: route => {
          const year = route.query.year ? parseInt(route.query.year as string) : dayjs().year();
          return { year };
        },
        component: () => import('@/pages/PaycheckReports/PaychecksAndBookkeepingReconciliationReport/paychecks-and-bookkeeping-reconciliation-report.vue'),
      },
    ],
  },
] as ISnotrRoute[];
